import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import AnnouncementBar from "@/components/AnnouncementBar";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import { api } from "@/lib/api";

// Simple policy / info page renderer. Content is admin-editable via the "Pages" tab.
// Body is stored as plain text with newlines; we render paragraphs preserving line breaks
// so the merchant does not need any HTML/Markdown knowledge.
export default function PolicyPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPage(null);
    setNotFound(false);
    api.get(`/pages/${slug}`)
      .then((r) => setPage(r.data))
      .catch(() => setNotFound(true));
    window.scrollTo(0, 0);
  }, [slug]);

  return (
    <div className="bg-[#0A0A0A] text-white min-h-screen flex flex-col" data-testid={`policy-page-${slug}`}>
      <AnnouncementBar />
      <Header />
      <main className="flex-1 max-w-3xl mx-auto px-5 md:px-8 py-16 w-full">
        {notFound ? (
          <div className="text-center py-24">
            <div className="text-[#D4AF37] uppercase tracking-[0.28em] text-xs mb-3">404</div>
            <h1 className="font-serif text-3xl mb-4">Page not found</h1>
            <Link to="/" className="text-[#D4AF37] hover:underline text-sm">← Back to homepage</Link>
          </div>
        ) : !page ? (
          <div className="text-white/40 text-sm">Loading…</div>
        ) : (
          <article>
            <div className="text-[#D4AF37] uppercase tracking-[0.28em] text-[0.65rem] mb-3">Luxury Hair by DEMJ</div>
            <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl mb-8 border-b border-[#2A2A2A] pb-6">
              {page.title}
            </h1>
            <div className="prose prose-invert max-w-none space-y-4 text-white/80 text-base leading-relaxed">
              {(page.body || "").split(/\n\n+/).map((para, i) => (
                <p key={i} className="whitespace-pre-line">{para}</p>
              ))}
            </div>
            {page.updated_at && (
              <div className="mt-10 pt-6 border-t border-[#1F1F1F] text-white/40 text-xs">
                Last updated {new Date(page.updated_at).toLocaleDateString()}
              </div>
            )}
          </article>
        )}
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
